import React, { Component, Fragment } from "react";
import {
  FormGroup,
  ControlLabel,
  Row,
  Col,
  FormControl,
  Checkbox,
} from "react-bootstrap";
import LoaderButton from "../../src/Component/LoaderButton";
import { fillRaritanExpungementForm } from "../libs/API";

class RaritanExpungement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      lastName: "",
      middleName: "",
      firstName: "",
      dataOfBirth: "",
      isAppendFile: "",
      isPrependExistingFile: "",
    };
    // console.log("AberdeenExpungement popup props", props);
  }

  async componentDidMount() {
    const selectedRow = this.props.selectedRow;
    console.log("selectedRow", selectedRow);
    const lastName = selectedRow[0]["Last Name"] || "";
    const firstName = selectedRow[0]["First Name"] || "";
    const middleName = selectedRow[0]["Middle Name"] || "";
    const dataOfBirth = selectedRow[0]["Date of Birth"] || "";

    this.setState({
      lastName,
      firstName,
      middleName,
      dataOfBirth,
    });
  }

  handleRaritanExpungementSubmit = async (e) => {
    e.preventDefault();
    this.setState({ isLoading: true });
    const jObject = {
      "Last Name": this.state.lastName,
      "First Name": this.state.firstName,
      "Middle Name": this.state.middleName,
      "Date of Birth": this.state.dataOfBirth,
    };

    const jArray = [];
    jArray.push(jObject);
    jArray.push({ fileId: this.props.selectedRow[0].FileId });
    const isAppendFile =
      this.state.isAppendFile === null || this.state.isAppendFile === ""
        ? false
        : true;
    const isPrependExistingFile =
      this.state.isPrependExistingFile === null ||
      this.state.isPrependExistingFile === ""
        ? false
        : true;
    // console.log(this.state.isPrependExistingFile, "hello");
    jArray.push({
      isAppendFile: isAppendFile,
      isPrependExistingFile: isPrependExistingFile,
    });

    fillRaritanExpungementForm(jArray)
      .then((data) => {
        if (data.status === 200) {
          // ✅ axios response has .status
          this.setState({ isLoading: false });
          this.props.closeParentPopup();
        }
      })
      .catch((err) => console.log(err));
  };

  render() {
    return (
      <Fragment>
        <form onSubmit={this.handleRaritanExpungementSubmit}>
          <FormGroup controlId="lastName">
            <Row>
              <Col sm={4} componentClass={ControlLabel}>
                Last Name:
              </Col>
              <Col sm={8}>
                <FormControl
                  className="input-box"
                  type="text"
                  required
                  readOnly
                  value={this.state.lastName}
                />
              </Col>
            </Row>
          </FormGroup>
          <FormGroup controlId="firstName">
            <Row>
              <Col sm={4} componentClass={ControlLabel}>
                First Name:
              </Col>
              <Col sm={8}>
                <FormControl
                  className="input-box"
                  type="text"
                  readOnly
                  value={this.state.firstName}
                />
              </Col>
            </Row>
          </FormGroup>
          <FormGroup controlId="middleName">
            <Row>
              <Col sm={4} componentClass={ControlLabel}>
                Middle Name:
              </Col>
              <Col sm={8}>
                <FormControl
                  className="input-box"
                  type="text"
                  readOnly
                  value={this.state.middleName}
                />
              </Col>
            </Row>
          </FormGroup>
          <FormGroup controlId="dateOfBirth">
            <Row>
              <Col sm={4} componentClass={ControlLabel}>
                Date of Birth:
              </Col>
              <Col sm={8}>
                <FormControl
                  className="input-box"
                  type="date"
                  readOnly
                  value={this.state.dataOfBirth}
                />
              </Col>
            </Row>
          </FormGroup>
          <FormGroup>
            <Row>
              <Col sm={4}>
                <LoaderButton
                  block
                  bsClass="btn btn-outline-secondary"
                  disabled={this.state.isLoading}
                  type="submit"
                  isLoading={this.state.isLoading}
                  text="Expunge Record"
                  loadingText="Expunging Record..."
                />
              </Col>

              {/* <Col sm={8}>
                <Checkbox
                  key={1}
                  onChange={(e) =>
                    this.setState({ isAppendFile: e.target.checked })
                  }
                >
                  {"   "} Append to Existing Expungement
                </Checkbox>
              </Col> */}
            </Row>
          </FormGroup>
          {/* <FormGroup>
            <Row>
              <Col sm={4}></Col>
              <Col sm={8}>
                <Checkbox
                  key={1}
                  onChange={(e) =>
                    this.setState({
                      isPrependExistingFile: e.target.checked,
                    })
                  }
                >
                  {"   "} Expunge and retain file
                </Checkbox>
              </Col>
            </Row>
          </FormGroup> */}
        </form>
      </Fragment>
    );
  }
}

export default RaritanExpungement;
